import en from './en';
import ar from './ar';
import bn from './bn';
import de from './de';
import el from './el';
import es from './es';
import fr from './fr';
import hi from './hi';
import it from './it';
import id from './id';
import ja from './ja';
import ko from './ko';
import pt from './pt';
import tr from './tr';
import ru from './ru';
import zhHans from './zh-hans';

const locales = {
    en,
    ar,
    bn,
    de,
    el,
    es,
    fr,
    hi,
    it,
    id,
    ja,
    ko,
    pt,
    tr,
    ru,
    'zh-hans': zhHans
};

export default locales;
